"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payments = void 0;
const data_access_1 = require("@resclick/data-access");
exports.payments = {
    create: {
        dto: data_access_1.PaymentCreateDto,
        method: 'Post',
        params: ['orderId'],
        path: '/orders/:orderId/payments',
        response: {},
    },
    create2: {
        dto: data_access_1.PaymentCreateDto,
        method: 'Post',
        params: ['orderId'],
        path: '/orders/:orderId/payments2',
        response: {},
    },
    update: {
        dto: data_access_1.PaymentUpdateDto,
        method: 'put',
        params: ['orderId', 'paymentId'],
        path: '/orders/:orderId/payments/:paymentId',
        response: {},
    },
    find: {
        method: 'get',
        path: '/payments',
        response: {},
    },
    findOne: {
        method: 'get',
        params: ['paymentId'],
        path: '/payments/:paymentId',
        response: {},
    },
    updateStatus: {
        method: 'put',
        params: ['paymentId'],
        path: '/payments/:paymentId/status',
        dto: data_access_1.PaymentUpdateStatusDto,
    },
    updateCompany: {
        method: 'put',
        params: ['paymentId'],
        path: '/payments/:paymentId/company',
        dto: data_access_1.PaymentUpdateCompanyDto,
    },
    cancel: {
        method: 'put',
        params: ['paymentId'],
        path: '/payments/:paymentId/cancel',
    },
    receiptDocument: {
        method: 'get',
        params: ['paymentId'],
        path: '/payments/:paymentId/receipt',
    },
    sendReceiptDocumentByEmail: {
        method: 'get',
        params: ['paymentId'],
        path: '/payments/:paymentId/documents/email',
        response: {},
    },
    createBalancePayment: {
        method: 'post',
        path: '/payments/balance-payments',
        dto: data_access_1.BalancePaymentCreateDto,
    },
    updateBalancePayment: {
        method: 'put',
        params: ['balancePaymentId'],
        path: '/payments/balance-payments/:balancePaymentId',
        dto: data_access_1.BalancePaymentUpdateDto,
    },
    findBalancePayment: {
        method: 'get',
        path: '/payments/balance-payments',
        response: {},
    },
    findOneBalancePayment: {
        method: 'get',
        params: ['balancePaymentId'],
        path: '/payments/balance-payments/:balancePaymentId',
        response: {},
    },
    createSpecialDiscount: {
        method: 'post',
        path: '/payments/special-discounts',
        dto: data_access_1.SpecialDiscountCreateDto,
    },
    updateSpecialDiscount: {
        method: 'put',
        params: ['specialDiscountId'],
        path: '/payments/special-discounts/:specialDiscountId',
        dto: data_access_1.SpecialDiscountUpdateDto,
    },
    findSpecialDiscounts: {
        method: 'get',
        path: '/payments/special-discounts',
        response: {},
    },
    findOneSpecialDiscount: {
        method: 'get',
        params: ['specialDiscountId'],
        path: '/payments/special-discounts/:specialDiscountId',
        response: {},
    },
    deleteSpecialDiscount: {
        method: 'delete',
        params: ['specialDiscountId'],
        path: '/payments/special-discounts/:specialDiscountId',
        response: {},
    },
    binQuery: {
        method: 'get',
        path: '/payments/bins',
        response: {},
    },
    excel: {
        method: 'get',
        path: '/payments/excel',
        response: {},
    },
};
//# sourceMappingURL=payments.api.js.map